import { Work } from "./"

export default class Workstation {
    uid: number;
    title: string;
    department : number;
    unit : number;
    workarea: number
    uuidWorkstation: string
    nfcChipReader: boolean
    presenceAllowed: boolean
    workbreakAllowed: boolean
    timeentryAllowed: boolean
    showAllProjectsAllowed: boolean
    works: Work[]
  
    constructor(uid: number, title: string, department : number, unit : number, workarea: number, 
        uuidWorkstation: string, nfcChipReader: boolean, presenceAllowed: boolean, workbreakAllowed: boolean, timeentryAllowed: boolean, 
        showAllProjectsAllowed :boolean, works: Array<Work>) {
        this.uid = uid;
        this.title = title;
        this.department = department
        this.unit = unit
        this.workarea = workarea
        this.uuidWorkstation = uuidWorkstation
        this.nfcChipReader = nfcChipReader
        this.presenceAllowed = presenceAllowed
        this.workbreakAllowed = workbreakAllowed
        this.timeentryAllowed = timeentryAllowed
        this.showAllProjectsAllowed = showAllProjectsAllowed
        this.works = works
    }

    static create() {
        return new Workstation(0, '', 0, 0, 0, '', false, false, false, false, false, [])
    }
    
    static createWorkstationsFromResponse(res:any) {
        const workstations :any = [];
        res.data.workstations.forEach((element: any) => {
            const works = [] as Array<Work>
            if (res.works) {
                for(const key in res.works) {
                    works.push(Work.createWorkFromResponse(res.works[key]))
                }
            }          
            workstations.push(new Workstation(element.uid, element.title, element.department?.uid || element.department, element.unit?.uid || element.unit, element.workarea?.uid || element.workarea, element.uuidWorkstation, element.nfcChipReader, element.presenceAllowed, element.workbreakAllowed, element.timeentryAllowed, element.showAllProjectsAllowed, works)
        )})
        return workstations;
    }

    static createWorkstationFromResponse(res:any) {
        //console.log('Workstation[createWorkstationFromResponse] -> res', res);
        const works = [] as Array<Work>
        if (res.works) {
            for(const key in res.works) {
                works.push(Work.createWorkFromResponse(res.works[key]))
            }
        }          
        return new Workstation (res.uid, res.title, res.department?.uid || res.department, res.unit?.uid || res.unit, res.workarea?.uid || res.workarea, res.uuidWorkstation, res.nfcChipReader, res.presenceAllowed, res.workbreakAllowed, res.timeentryAllowed, res.showAllProjectsAllowed, works);
    }
    
    /**** getters & setters ****/

    getUid() {
        return this.uid;
    }

    setUid(uid:number) {
        this.uid = uid;
    }  

    getTitle() {
    return this.title;
    }

    setTitle(title:string) {
        this.title = title;
    }

    getDepartment() {
        return this.department;
    }

    setDepartment(department:number) {
        this.department = department;
    }

    getUnit() {
        return this.unit;
    }

    setUnit(unit:number) {
        this.unit = unit;
    }

    getWorkarea() {
        return this.workarea;
    }

    setWorkarea(workarea:number) {
        this.workarea = workarea;
    }

    getUuidWorkstation() {
        return this.uuidWorkstation;
    }

    setUuidWorkstation(uuidWorkstation:string) {
        this.uuidWorkstation = uuidWorkstation;
    }    

    getNfcChipReader() {
        return this.nfcChipReader;
    }

    setNfcChipReader(nfcChipReader:boolean) {
        this.nfcChipReader = nfcChipReader;
    }        

    getPresenceAllowed() {
        return this.presenceAllowed;
    }

    setPresenceAllowed(presenceAllowed:boolean) {
        this.presenceAllowed = presenceAllowed;
    }     

    getWorkbreakAllowed() {
        return this.workbreakAllowed;
    }

    setWorkbreakAllowed(workbreakAllowed:boolean) {
        this.workbreakAllowed = workbreakAllowed;
    }     

    getTimeentryAllowed() {
        return this.timeentryAllowed;
    }

    setTimeentryAllowed(timeentryAllowed:boolean) {
        this.timeentryAllowed = timeentryAllowed;
    }     

    getShowAllProjectsAllowed() {
        return this.showAllProjectsAllowed;
    }

    setShowAllProjectsAllowed(showAllProjectsAllowed:boolean) {
        this.showAllProjectsAllowed = showAllProjectsAllowed;
    }      
}
